import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const updateProjectGroup = api(async function updateProjectGroup({ projectId, group }) {
    return mutate(
        gql`
            mutation UpdateProjectGroup($projectId: String!, $group: ProjectGroupInput!) {
                updateProjectGroup(projectId: $projectId, group: $group)
            }
        `,
        { projectId, group },
        { returns: "updateProjectGroup" }
    )
})
